import { FC, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
// Mui
import { Box } from '@mui/material';
// Components
import { Fab } from 'app/components/Mui';
// Hooks
import useCaseStatus from 'app/hooks/useCaseStatus';
import useToggle from 'app/hooks/useToggle';
import useAccountStatus from 'app/hooks/useAccountStatus';
// 
import ReportFormDialog from './ReportFormDialog';

const ReportsFab:FC = () => {
  const { t } = useTranslation();

  const { isArchived } = useCaseStatus();
  const { isSuspended } = useAccountStatus();

  const { open, toggle } = useToggle();

  const isDisabled = isArchived || isSuspended;

  return (
    <Fragment>
      <Box sx={{
        position: 'fixed',
        right: 16,
        bottom: 16,
        display: 'flex',
        gap: 4
      }}>
        <Fab
          name="Create report"
          disabled={isDisabled}
          onClick={toggle}
          color="primary"
          variant="extended"
        >{t('pages.reports.createButton')}</Fab>
      </Box>
      {open ? (
        <ReportFormDialog
          open={open}
          onClose={toggle}
        />
      ) : null}
    </Fragment>
  )
}

export default ReportsFab;
